import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { userAtom } from "@Recoil/Atom/userAtom"
import { UserService } from "@Services/User.service"
import { LocalStorage } from "@Services/sharedPreferences/localStorage"
import { useNavigation } from "@react-navigation/native"
import { useState } from "react"
import { useRecoilValue } from "recoil"

export const useConsentHooks = () => {
    const [fetchingPatientConsent, setFetchingPatientConsent] = useState(true)
    const [saving, setSaving] = useState(false)
    const [updateData, setUpdateData] = useState(false)
    const navigation = useNavigation()

    const user = useRecoilValue(userAtom)
    const [patientConsent, setPatientConsent] = useState({
        condition: null,
        isUserMajor: null,
        appServices: null,
        anonymiseMyData: null,
        commercialOffer: null
    })

    const handleFetchConsent = () => {
        setFetchingPatientConsent(true)
        UserService.getConsent(user?.id)
            .then((response) => {
                const data = response.data?.data
                console.log({})
                setFetchingPatientConsent(false)
                if (data?.length > 0) {
                    const status = {
                        condition: data?.[0]?.cgu,
                        isUserMajor: data?.[0]?.major,
                        appServices: data?.[0]?.services,
                        anonymiseMyData: data?.[0]?.communication,
                        commercialOffer: data?.[0]?.statistics,
                        participateInStudy: data?.[0]?.participateInStudy
                    }
                    setPatientConsent(status)
                    LocalStorage.saveConsentStatus(status)
                }
            })
            .catch((e) => {
                console.error({ ErrorFetchingPatientConsent: e })
                setFetchingPatientConsent(false)
            })
    }

    const performSaveConsent = ({ payload }) => {
        setSaving(true)
        if (user) {
            UserService.saveConsent(payload)
                .then((response) => {
                    setSaving(false)
                    setUpdateData((prev) => !prev)
                    ShowToast({ type: "success", message: "Consentement enregistré avec succès" })
                })
                .catch((e) => {
                    setSaving(false)
                    ShowToast({ type: "error", message: "oops ! une errreur est survenue" })
                })
        }
    }

    const performSaveNoticeConsent = ({ payload }) => {
        const data = { ...payload, participateInStudy: Number(payload.participateInStudy) }
        setSaving(true)
        console.log({ payload: data })
        if (user) {
            UserService.saveConsent(data)
                .then((response) => {
                    const data = response.data?.data
                    if (data) {
                        const status = {
                            condition: data?.cgu,
                            isUserMajor: data?.major,
                            appServices: data?.services,
                            anonymiseMyData: data?.communication,
                            commercialOffer: data?.statistics,
                            participateInStudy: data?.participateInStudy
                        }
                        setPatientConsent(status)
                        if (payload.participateInStudy) {
                            LocalStorage.saveConsentStatus(status).then(() =>
                                navigation.navigate("DiagnosticEducatifList")
                            )
                        }
                    }
                    ShowToast({ type: "success", message: "Consentement enregistré avec succès" })
                    setSaving(false)
                })
                .catch((e) => {
                    setSaving(false)
                    ShowToast({ type: "error", message: "oops ! une errreur est survenue" })
                })
        }
    }

    return {
        handleFetchConsent,
        patientConsent,
        fetchingPatientConsent,

        performSaveConsent,
        saving,
        updateData,

        performSaveNoticeConsent
    }
}
